import * as React from "react";
import type { SVGProps } from "react";
const SvgMap03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M8.4 20.035V5.739M15 17.635V3.265M2.4 18.26V3.235l5.843 2.504 6.679-2.504L21.6 5.739v15.026l-6.678-2.504-6.679 2.504z"
    />
  </svg>
);
export default SvgMap03;
